export default __webpack_public_path__ + "static/media/food.26c5689b.png";